<template>
  <v-dialog
    :value="openModal"
    persistent
    @close="$emit('closeModal')"
    max-width="500"
    :content-class="'ModalCreateBanner'"
  >
    <v-card class="ModalCreateBanner__card d-flex flex-column px-6 py-4">
      <div class="ModalCreateBanner__close d-flex justify-end">
        <v-btn
          small
          @click="$emit('closeModal')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="ModalCreateBanner__title">
        Добавить баннер
      </div>
      <div class="ModalCreateBanner__file" v-if="!uploadFile.isUpload">
        <upload-box
          :accept-file="['jpg', 'png']"
          v-model="uploadFile.image"
          @upload="clickSubmit"
        />
      </div>
      <div v-else>
        <v-img
          :src="uploadFile.imageBase64"
          alt="preview_banner"
        />
      </div>
      <div class="ModalCreateBanner__btn-group">
        <div>
          <v-btn
            class="mr-3 _w-100"
            outlined
            color="primary"
            @click="cancel"
          >
            Отменить
          </v-btn>
        </div>
        <div>
          <v-btn
            class="_w-100"
            color="primary"
            @click="okClicked"
          >
            Добавить
          </v-btn>
        </div>

      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import UploadBox from '@/components/candidates/profile/dossier/UploadBox.vue';

/**
 * Компонент: ModalCreateBanner
 * Описание:
 */
export default {
  name: 'ModalCreateBanner',

  components: { UploadBox },

  props: {
    openModal: {
      type: Boolean,
      default: false
    },
    uploadFile: {
      type: Object,
      default: () => ({
        isUpload: false,
        image: null,
      }),
    }
  },
  emits: ['closeModal', 'upload:file'],

  data() {
    return {
      currentFile: null
    };
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    clickSubmit(file) {
      this.$emit('upload:file', file);
    },
    okClicked() {
      this.$emit('uploadBanner', this.uploadFile.image);
    },
    cancel() {
      this.$emit('closeModal');
    }
  },
};
</script>

<style scoped lang="scss">
.ModalCreateBanner{
  &__card{
    border-radius: 20px !important;
    box-shadow: none !important;
    gap: 24px;
  }

  &__close{
    & > button{
      box-shadow: none !important;
      background: transparent;
    }
  }

  &__title {
    font-size: 22px;
    color: var(--color-blue-500);
    font-weight: 600;
  }

  &__btn-group{
    display: flex;
    justify-content: flex-end;
  }

}
</style>
